export function gALLESPROPERTIESNEWTITLEORDER() {
return [   //2024 Release 2025-11-09 20:50:27
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Title Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 107.4,
   left: 142.36,
   width: 105.96,
   height: 13.755
}
,
{
   page: 0,
   name: "Date Order Date", 
   fontSize: 9,
   type: "date",
   top: 107.4,
   left: 314.012,
   width: 50.151,
   height: 13.755
}
,
{
   page: 0,
   name: "Submitted By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 107.4,
   left: 442.6,
   width: 94.44,
   height: 13.755
}
,
{
   page: 0,
   name: "Property Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 133.6,
   left: 159.16,
   width: 268.92,
   height: 13.755
}
,
{
   page: 0,
   name: "MLS", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 133.6,
   left: 473.08,
   width: 63.96,
   height: 13.755
}
,
{
   page: 0,
   name: "Date Closing Date", 
   fontSize: 9,
   type: "date",
   top: 208.48,
   left: 123.88,
   width: 79.56,
   height: 13.755
}
,
{
   page: 0,
   name: "Sale Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 208.48,
   left: 305.08,
   width: 78.60,
   height: 13.755
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 208.48,
   left: 465.16,
   width: 70.44,
   height: 13.755
}
,
{
   page: 0,
   name: "Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 231.36,
   left: 132.72,
   width: 68.52,
   height: 13.755
}
,
{
   page: 0,
   name: "Date Due", 
   fontSize: 9,
   type: "date",
   top: 230.36,
   left: 300.72,
   width: 80.76,
   height: 13.755
}
,
{
   page: 0,
   name: "Listing Broker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.48,
   left: 127.68,
   width: 160.68,
   height: 13.755
}
,
{
   page: 0,
   name: "Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.48,
   left: 338.52,
   width: 107.52,
   height: 13.755
}
,
{
   page: 0,
   name: "Commission", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 292.24,
   left: 510.0,
   width: 38.04,
   height: 13.755
}
,
{
   page: 0,
   name: "Selling Broker", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 316.48,
   left: 127.2,
   width: 161.16,
   height: 13.755
}
,
{
   page: 0,
   name: "Company_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 316.48,
   left: 338.52,
   width: 107.52,
   height: 13.755
}
,
{
   page: 0,
   name: "Commission_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 317.44,
   left: 510.0,
   width: 38.04,
   height: 13.755
}
,
{
   page: 0,
   name: "ReferralsOther Paid By Title", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 340.72,
   left: 198.48,
   width: 248.40,
   height: 13.755
}
,
{
   page: 0,
   name: "Amount", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.32,
   left: 491.76,
   width: 56.04,
   height: 13.755
}
,
{
   page: 0,
   name: "Seller Names And Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 402.88,
   left: 199.92,
   width: 347.64,
   height: 13.755
}
,
{
   page: 0,
   name: "Seller Mailing Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 426.88,
   left: 166.44,
   width: 380.64,
   height: 13.755
}
,
{
   page: 0,
   name: "Seller Phones", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 452.76,
   left: 133.56,
   width: 119.28,
   height: 11.373
}
,
{
   page: 0,
   name: "Seller Emails", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 452.76,
   left: 326.16,
   width: 220.92,
   height: 11.373
}
,
{
   page: 0,
   name: "Buyer Names And Company", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 486.88,
   left: 198.36,
   width: 348.72,
   height: 13.755
}
,
{
   page: 0,
   name: "Buyer Mailing Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 510.88,
   left: 168.0,
   width: 378.48,
   height: 13.755
}
,
{
   page: 0,
   name: "Buyer Phones", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 536.88,
   left: 135.6,
   width: 111.72,
   height: 11.373
}
,
{
   page: 0,
   name: "Buyer Emails", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 536.88,
   left: 323.04,
   width: 224.04,
   height: 11.373
}
,
{
   page: 0,
   name: "Text21", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 587.39,
   left: 59.5327,
   width: 492.9083,
   height: 176.7846
}
] }
